import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.parse-int.js";
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";

import { useSlots, ref, reactive, provide, computed, watch, onMounted } from 'vue';
var _hoisted_1 = ["data-link", "onClick"];
var _hoisted_2 = ["innerHTML"];
export default {
  __name: 'PBTabs',
  props: {
    modelValue: {
      type: String,
      "default": ""
    },
    disabled: Boolean,
    border: Boolean,
    vertical: Boolean,
    black: Boolean,
    topRounded: Boolean,
    fullBlack: {
      type: Boolean,
      "default": true
    },
    topPadding: {
      type: Boolean,
      "default": true
    },
    labelHtml: {
      type: Boolean,
      "default": true
    }
  },
  emits: ["update:modelValue"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var slots = useSlots();
    var activeTab = ref("");
    var tabs = ref([]);
    var selectedIndex = ref(0);
    var titlesListRef = ref(null);
    var line = reactive({
      left: 0,
      width: 0,
      top: "",
      height: ""
    });
    provide("selectedTab", activeTab);
    var tabTitles = computed(function () {
      var _tabs$value;
      return (_tabs$value = tabs.value) === null || _tabs$value === void 0 ? void 0 : _tabs$value.map(function (tab) {
        var _tab$props;
        return tab === null || tab === void 0 || (_tab$props = tab.props) === null || _tab$props === void 0 ? void 0 : _tab$props.label;
      }).filter(Boolean);
    });
    var isSingleTab = computed(function () {
      return tabTitles.value.length === 1;
    });
    function getTabButton() {
      if (!titlesListRef.value) {
        return null;
      }
      var tabButtons = _toConsumableArray(titlesListRef.value.querySelectorAll("a"));
      return tabButtons.find(function (button) {
        return button.dataset.link === "link-".concat(selectedIndex.value);
      });
    }
    function prepareTabsOnMounted() {
      var _filteredSlots$;
      var filteredSlots = slots["default"]().filter(function (slot) {
        var _slot$children;
        return slot.children !== "v-if" && (!!slot.props || ((_slot$children = slot.children) === null || _slot$children === void 0 ? void 0 : _slot$children.length) > 0);
      });
      tabs.value = (_filteredSlots$ = filteredSlots[0]) !== null && _filteredSlots$ !== void 0 && _filteredSlots$.props ? filteredSlots : filteredSlots[0].children;
      activeTab.value = props.modelValue || tabTitles.value[0];
      selectedIndex.value = tabTitles.value.findIndex(function (label) {
        return label === activeTab.value;
      });
      setTimeout(setLine);
    }
    function setLine() {
      var tabButton = getTabButton();
      if (!tabButton) {
        return;
      }
      if (props.vertical) {
        var _titlesListRef$value, _tabButton$getBoundin;
        line.left = "0px";
        line.width = "2px";
        var parentPos = parseInt((_titlesListRef$value = titlesListRef.value) === null || _titlesListRef$value === void 0 || (_titlesListRef$value = _titlesListRef$value.getBoundingClientRect()) === null || _titlesListRef$value === void 0 ? void 0 : _titlesListRef$value.top, 10);
        var childPos = parseInt(tabButton === null || tabButton === void 0 || (_tabButton$getBoundin = tabButton.getBoundingClientRect()) === null || _tabButton$getBoundin === void 0 ? void 0 : _tabButton$getBoundin.top, 10);
        var offset = childPos - parentPos;
        line.top = "".concat(offset, "px");
        line.height = "".concat(tabButton.offsetHeight, "px");
      } else {
        var _titlesListRef$value2, _tabButton$getBoundin2;
        var _parentPos = parseInt((_titlesListRef$value2 = titlesListRef.value) === null || _titlesListRef$value2 === void 0 || (_titlesListRef$value2 = _titlesListRef$value2.getBoundingClientRect()) === null || _titlesListRef$value2 === void 0 ? void 0 : _titlesListRef$value2.left, 10);
        var _childPos = parseInt(tabButton === null || tabButton === void 0 || (_tabButton$getBoundin2 = tabButton.getBoundingClientRect()) === null || _tabButton$getBoundin2 === void 0 ? void 0 : _tabButton$getBoundin2.left, 10);
        var _offset = _childPos - _parentPos;
        line.left = "".concat(_offset, "px");
        line.width = "".concat(tabButton.clientWidth, "px");
      }
    }
    function selectTab(_x) {
      return _selectTab.apply(this, arguments);
    }
    function _selectTab() {
      _selectTab = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
        var label, index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              label = _ref2.label, index = _ref2.index;
              if (!(activeTab.value === label || props.disabled)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              activeTab.value = label;
              selectedIndex.value = index;
              setLine();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _selectTab.apply(this, arguments);
    }
    watch(activeTab, function (value, old) {
      if (value === old) {
        return;
      }
      emit("update:modelValue", value);
    });
    watch(function () {
      return props.modelValue;
    }, function (value, old) {
      if (value === old) {
        return;
      }
      var index = tabTitles.value.findIndex(function (label) {
        return label === value;
      });
      activeTab.value = value;
      selectedIndex.value = index;
      setLine();
      emit("update:modelValue", value);
    });
    onMounted(prepareTabsOnMounted);
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["PBTabs", {
          'PBTabs--black': __props.fullBlack,
          'PBTabs--vertical': __props.vertical
        }])
      }, [_createElementVNode("div", {
        "class": _normalizeClass(["PBTabs__top", {
          'PBTabs__top--black': __props.black,
          'PBTabs__top--border': __props.border || _unref(tabs).length === 1,
          'PBTabs__top--padding': __props.topPadding,
          'PBTabs__top--rounded': __props.topRounded,
          'PBTabs__top--vertical': __props.vertical
        }])
      }, [_renderSlot(_ctx.$slots, "title"), _createElementVNode("div", {
        "class": _normalizeClass(["PBTabs__list", {
          'PBTabs__list--single': _unref(isSingleTab)
        }])
      }, [_createElementVNode("ul", {
        ref_key: "titlesListRef",
        ref: titlesListRef,
        "class": _normalizeClass({
          'PBTabs__list--vertical': __props.vertical
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabTitles), function (label, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          "class": _normalizeClass(["PBTabs__list-element", {
            'PBTabs__list-element--vertical': __props.vertical
          }])
        }, [_createElementVNode("a", {
          href: "#",
          "class": _normalizeClass({
            active: index === _unref(selectedIndex)
          }),
          "data-link": "link-".concat(index),
          onClick: _withModifiers(function ($event) {
            return selectTab({
              label: label,
              index: index
            });
          }, ["prevent"])
        }, [__props.labelHtml ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          innerHTML: label
        }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("span", null, _toDisplayString(label), 1), _renderSlot(_ctx.$slots, "tab-after", {
          label: label
        })], 64))], 10, _hoisted_1)], 2);
      }), 128))], 2), !_unref(isSingleTab) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "PBTabs__line",
        style: _normalizeStyle(_unref(line))
      }, null, 4)) : _createCommentVNode("", true)], 2), _renderSlot(_ctx.$slots, "top")], 2), _createElementVNode("div", {
        "class": _normalizeClass(["PBTabs__content flex-1 flex flex-col", {
          'PBTabs__content--vertical': __props.vertical
        }])
      }, [_renderSlot(_ctx.$slots, "default")], 2)], 2);
    };
  }
};